<template>
    <v-dialog :value="exibirModal && requisicaoEditar" persistent :max-width="'550'">
        <v-card>
            <v-card-title class="primary modal-title" primary-title>
                <span>
                    Alterar Data/Hora Entrada
                </span>
            </v-card-title>
            <v-card-text v-if="requisicaoEditar">
                <span>
                    Escreva uma nova Data/Hora Entrada para a requisição {{requisicaoEditar.id}}:
                </span>

                <br>
                <br>

                <v-text-field label="Data/Hora Entrada" :name="'Data/Hora Entrada' + requisicaoEditar.id" class="required-field"
                              :key="'Data-Hora-Entrada' + requisicaoEditar.id"
                              placeholder="Ex. 19/01/2022 - 14h 34min" :error-messages="errors.collect('Data/Hora Entrada' + requisicaoEditar.id)"
                              v-model="dataHoraEntrada" v-validate="'required'"/>

            </v-card-text>

            <v-card-actions>
                <v-flex>
                    <div class="lista-opcoes__acao">
                        <az-call-to-action id="botaoConfirmar"
                                           @click="$emit('cancelar')"
                                           css-class="botao" class="ma-2 py-2"
                                           slot="actions">
                            Cancelar
                        </az-call-to-action>
                        <az-call-to-action id="botaoFechar"
                                           @click="confirmar()"
                                           css-class="botao-desativado" class="ma-2 py-2"
                                           slot="actions">
                            Confirmar
                        </az-call-to-action>
                    </div>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ModalEditarDataHoraEntradaRequisicao',
    props: {
        exibirModal:{
            type: Boolean,
            default: false
        },
        requisicaoEditar:{
            type: Object,
            default: null,
        }
    },
    data(){
        return{
            dataHoraEntrada: null
        }
    },
    mounted(){
        this.dataHoraEntrada = this.requisicaoEditar.dataHoraEntrada
    },
    methods:{
        confirmar() {
            if(!this.dataHoraEntrada || this.dataHoraEntrada.trim().length === 0){
                throw new Error('Data/Hora não informada!')
            }
            this.requisicaoEditar.dataHoraEntrada = this.dataHoraEntrada
            this.$emit('confirmar', this.requisicaoEditar)
        }
    }
}
</script>

<style scoped lang="stylus">
    .lista-opcoes
        text-align center

        &__acao
            display flex
            justify-content space-between
            text-align center

    .botao-desativado
        color #777 !important
</style>
